import { RenderingProps } from '@/shared/shared.types';
import { LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

export type C08LinkListItemProps = RenderingProps<C08LinkListItemFields>;

export type C08LinkListItemFields = {
  Link?: LinkField;
};
